import camelCase from 'lodash.camelcase';
import { validationMixin } from 'vuelidate';
import FormInput from '@/components/form/Input.vue';
import MarkupForm from '@/components/markup/popup/form';

import { VARIANT_ERROR } from '@/components/markup/popup/form/notification';

const STATUS_READY = 'ready';
const STATUS_WAIT = 'wait';
const STATUS_ERROR = 'error';

export default {
  components: {
    FormInput,
    MarkupForm,
  },

  mixins: [validationMixin],

  props: {
    validateBeforeSubmit: {
      type: Boolean,
      value: false,
    },

    defaultErrorText: {
      type: Array,
      default: () => [
        {
          content: 'Некоторые поля формы заполнены неверно',
          strong: true,
        },
        'Проверьте правильность заполнения и отправьте запрос заново',
      ],
    },
  },

  data: () => ({
    errors: [],
    status: STATUS_READY,
  }),

  computed: {
    isDisabled() {
      if (this.$v && this.$v.$invalid) {
        return this.status === STATUS_WAIT || this.$v.$invalid;
      }
      // TODO: пока что будет ругаться при сборке без обновления бабел
      return this.status === STATUS_WAIT;
    },

    requestData() {
      return {};
    },

    hasErrors() {
      return this.errors && this.errors.length > 0;
    },

    errorsObject() {
      return this.errors.reduce((res, { attribute, msg }) => {
        res[attribute] = msg;
        return res;
      }, {});
    },

    errorsText() {
      return Object.keys(this.errorsObject).reduce((res, key) => {
        if (this[key] && this[key].length > 0) {
          res[key] = this.errorsObject[key];
        }
        return res;
      }, {});
    },

    isEmailRegisteredError() {
      const { email } = this.errorsText;
      if (!email && typeof email !== 'string') return false;
      return email.includes('зарегистрирован');
    },

    errorMessage() {
      const { message } = this;
      return message
        ? {
            variant: VARIANT_ERROR,
            items: message,
          }
        : null;
    },
  },

  methods: {
    runAction() {
      return Promise.reject({
        msg: 'Необходимо переопределить метод runAction',
      });
    },

    onSubmit() {
      const { $v, validateBeforeSubmit } = this;

      if (validateBeforeSubmit) {
        $v.$touch();
        if ($v.$invalid) {
          if (typeof this.fillErrors === 'function') {
            this.fillErrors();
          }
          // return;
        }
      }

      this.status = STATUS_WAIT;
      this.runAction(this.requestData)
        .then((res) => {
          this.status = STATUS_READY;
          this.$emit('submit');
          // TODO FIXIT - разобраться почему hash: false сбрасывает query параметры
          if (this.$route.name !== 'inquiry')
            this.$router.push({ hash: false });
        })
        .catch((err) => {
          this.status = STATUS_ERROR;
          this.errors.splice(0, this.errors.length);
          if (Array.isArray(err)) {
            this.errors.push(
              ...err.map(({ attribute, msg }) => ({
                msg,
                attribute: camelCase(attribute),
              })),
            );
          } else {
            this.defaultErrorText = [
              {
                content: 'Ошибка сервера, попробуйте позже',
                strong: true,
              }
            ]
          }
        });
    },

    resetError(name) {
      const index = this.errors.findIndex(
        ({ attribute }) => attribute === name,
      );
      if (index !== -1) {
        this.errors.splice(index, 1);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/default/popup/forms/sign-mixin.js